import { render, staticRenderFns } from "./huishouidan.vue?vue&type=template&id=78c228a2&scoped=true&"
import script from "./huishouidan.vue?vue&type=script&lang=js&"
export * from "./huishouidan.vue?vue&type=script&lang=js&"
import style0 from "./huishouidan.vue?vue&type=style&index=0&id=78c228a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c228a2",
  null
  
)

export default component.exports